<template>
  <div>
    <arrorImg bg="white"></arrorImg>
    <navBar title="活动详情" color="#ffffff" :pagetype="pageType"></navBar>
    <div class="activity-image">
      <img class="activity-img" :src="joinPicture" alt="" />
    </div>
    <div class="btn-activity" @click="goPay">
      <span class="btn-text">立即参加</span>
    </div>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
	  name: "bookActivity",
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      activityId: 0,
      payItem: {
        settingsId: 0,
        money: 0, // 单位:分
        bookId: 0,
        chapterId: 0,
        vipId: 0,
        activityId: 0, //活动编号 ，会员和充值默认为0
      },
      joinPicture: "",
      out_trade_no: "",
      pageType: "",
      isEntranceData: "",
      messageType: "", //消息类型
      clickMessId: 0, //消息ID
      channelRecordId: 0, //渠道号
      promotionCode: "", //推广链接
      isBookRead: "",
    };
  },
  mounted() {
   
	  var that = this;
    window.addEventListener("pageshow", function (e) {
      //如果检测到页面是从“往返缓存”中读取的，刷新页面
      if (e.persisted) {
        that.getOrderStatus();
      }
    });
  },
  activated() {
      this.activityId = this.$route.query.activityId;
    this.payItem.activityId = this.$route.query.activityId;
    this.pageType = this.$route.query.pageType;
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }

    if (this.$route.query.isBookRead) {
      this.isBookRead = this.$route.query.isBookRead;
      console.log(this.isBookRead);
    }
    if (this.$route.query.bookId) {
      this.payItem.bookId = this.$route.query.bookId;
      this.payItem.chapterId = this.$route.query.chapterId;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.findRechargeActivityById();
    } else {
      this.findRechargeActivityById();
    }
    this.$commonApi.share();
  },
    beforeRouteEnter(to, from, next) {
    if (to.name == "bookActivity" && !from.name ) {
      // 不刷新当前页面
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    } else {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    }
    console.log(from);
    console.log(to);
    next();
  },
  methods: {
getOrderStatus() {
        console.log("订单支付成功1111");
      var isActivity = this.$base.getStorage("isActivity");
      if (isActivity == 1 && this.$base.getStorage("orderNum")) {
        //订单支付成功
        console.log("订单支付成功");
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 2,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("isActivity");
          this.$base.removeStorage("orderNum");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    insertPageAccessData(activeName) {
      var prevPage = "充值中心";
      if (this.pageType === "bookTask") {
        prevPage = "任务中心";
      } else if (this.pageType === "bookMine") {
        prevPage = "我的";
      } else if (this.pageType === "bookRead") {
        prevPage = "阅读器";
      } else if (this.pageType === "bookCity") {
        prevPage = "书城";
      } else if (this.pageType === "bookRecharge") {
        prevPage = "充值中心";
      }
      var params = {
        pageName: "活动详情",
        pageRemark: "活动名称：" + activeName + "；上级页面：" + prevPage,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    findRechargeActivityById() {
      var params = {
        activityId: this.activityId,
      };
      this.$api.findRechargeActivityById(params).then((res) => {
        if (res.status == 1) {
          this.payItem.money = res.data.rechargeMoney;
          this.url = res.data.url;
          this.joinPicture = res.data.joinPicture;
          this.insertPageAccessData(res.data.activeName);
		   this.getOrderStatus();
        }
      });
    },
    goPay() {
      this.$api.separateWxpay(this.payItem).then((res) => {
        if (res.status == 1) {
          // h5公众号微信支付
          var data = res.data;
          // #ifdef H5
          var pageType = "";
          if (this.pageType == "bookRead") {
            pageType = "bookRead";
          } else {
            pageType = "bookActivity";
          }
          // if(this.isBookRead=='bookRead'||pageType=='bookRead'){
          this.$base.setStorage("isActivity", 1);
          this.$base.setStorage("orderNum", data.orderNo);
          // }
          var url_config = "https://" + window.location.host + "/";
          var WXurl = this.$commonApi.PayURL(); //环境
          var URL =
            WXurl +
            "/payIndex.html?pageType=" +
            this.pageType +
            "&type=bookActivity&orderNo=" +
            data.orderNo +
            "&officialCode=" +
            data.officialCode +
            "&openid=" +
            this.$base.getStorage("openid") +
            "&configUrl=" +
            url_config +
            "&isBookRead=" +
            this.isBookRead;
          window.location.href = URL;
        } else if (res.status == 0) {
          Toast({
            message: res.message,
          });
        }
      });
    },
    getUserCurrency() {
      this.$api.getUserCurrency().then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currency", res.data);
        }
      });
    },
  },
};
</script>

<style scoped>
.activity-image {
  width: 100%;
  padding-bottom: 44px;
  padding-top: calc(44px + env(safe-area-inset-top));
}

.activity-img {
  width: 100%;
}

.btn-activity {
  width: 100%;
  height: 44px;
  text-align: center;
  background-color: #de3b34;
  position: fixed;
  bottom: 0px;
  left: 0;
}

.btn-text {
  line-height: 44px;
  color: #ffffff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookActivity/index.vue